<template>
  <div class="general-info listing-service-sections-block">
    <div class="general-info__container">
      <div v-if="heading" class="general-info__title-left">
        <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ heading }}</h1>
      </div>

      <template v-for="(sec, idx) in sections">
        <!-- image left — как statistics-section4 -->
        <section
          v-if="!isImageRight(sec)"
          :key="'svc-l-' + idx"
          class="statistics-section4"
        >
          <div class="statistics-section4__container statistics-section4__wrap-index-block">
            <div class="statistics-section4__index-block-white">
              <div v-if="sec.image" class="statistics-section4__img">
                <img :src="sec.image" :alt="sec.title || ''">
              </div>
              <div class="statistics-section4__wrap-info-text">
                <div v-if="sec.title" class="statistics-section4__title">
                  <p class="text-TTDrugs-Bold-40 color-green">{{ sec.title }}</p>
                </div>
                <div class="statistics-section4__flex">
                  <div v-if="sec.subtitle" class="statistics-section4__subtitle">
                    <p class="text-circe-bold-22">{{ sec.subtitle }}</p>
                  </div>
                  <div v-if="sec.section_title" class="statistics-section4__description">
                    <p class="text-circe-bold-22 color-green">{{ sec.section_title }}</p>
                  </div>
                  <div v-if="sec.content" class="statistics-section4__text">
                    <p class="text-circe-20">{{ sec.content }}</p>
                  </div>
                </div>
                <div
                  v-if="sec.button && sec.button.text"
                  class="statistics-section4__btn"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  @click="goTo(sec)"
                >
                  <button type="button" class="index-btn">{{ sec.button.text }}</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- image right — как statistics-section3 -->
        <section
          v-else
          :key="'svc-r-' + idx"
          class="statistics-section3"
        >
          <div class="statistics-section3__container">
            <div class="statistics-section3__wrap-index-block-white">
              <div class="statistics-section3__index-block">
                <div v-if="sec.title" class="statistics-section3__title">
                  <p class="text-TTDrugs-Bold-40 color-green">{{ sec.title }}</p>
                </div>
                <div class="statistics-section3__wrap-info-text">
                  <div class="statistics-section3__flex">
                    <div class="statistics-section3__info">
                      <div v-if="sec.subtitle" class="statistics-section3__subtitle">
                        <p class="text-circe-bold-22">{{ sec.subtitle }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="statistics-section3__flex">
                    <div v-if="sec.section_title" class="statistics-section3__description">
                      <p class="text-circe-bold-22 color-green">{{ sec.section_title }}</p>
                    </div>
                    <div v-if="sec.content" class="statistics-section3__text">
                      <p class="text-circe-20">{{ sec.content }}</p>
                    </div>
                    <div
                      v-if="sec.button && sec.button.text"
                      class="statistics-section3__btn"
                      data-aos="fade-up"
                      data-aos-duration="1000"
                      @click="goTo(sec)"
                    >
                      <button type="button" class="index-btn">{{ sec.button.text }}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="sec.image" class="statistics-section3__img">
                <img :src="sec.image" :alt="sec.title || ''">
              </div>
            </div>
          </div>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
import 'aos/dist/aos.css'
import AOS from 'aos'

export default {
  name: 'AppListingServiceSectionsBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    heading() {
      return (this.data && this.data.heading) || ''
    },
    sections() {
      const list = this.data && this.data.sections
      return Array.isArray(list) ? list : []
    },
  },
  mounted() {
    AOS.init()
  },
  methods: {
    isImageRight(sec) {
      return sec && sec.imagePosition === 'right'
    },
    normalizeLink(link) {
      const raw = String(link || '').trim()
      if (!raw) return ''
      if (/^https?:\/\//i.test(raw)) return raw
      if (raw.startsWith('/')) return raw
      return `/${raw}`
    },
    goTo(sec) {
      const href = this.normalizeLink(sec && sec.button && sec.button.link)
      if (!href) return
      if (/^https?:\/\//i.test(href)) {
        window.location.href = href
        return
      }
      this.$router.push(href)
    },
  },
}
</script>

<style scoped>
</style>
